import { useState, useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
export default function HeroSection() {
  const ref = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section ref={ref} className="relative min-h-[120vh] flex items-center justify-center overflow-hidden bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/garden_machinery_hero.png)]">
      {}
      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/garden_machinery_hero.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/garden_machinery_hero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/garden_machinery_hero.png-wvc-sizes" alt="Professional garden machinery servicing in Carlisle" className="absolute inset-0 w-full h-full object-cover" loading="lazy" src="https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-16-at-18.41.42.jpeg" />

      {}
      <div className="absolute inset-0 bg-black/50 z-0" />

      <div className="page-container relative z-10 py-20">
        <div className={`flex flex-col items-center text-center transition-all duration-1000 ease-out ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="font-serif text-white font-bold leading-tight mb-6 max-w-5xl !text-[55px]">About TM Plant</h1>

          <p className="font-sans text-white/90 leading-relaxed mb-10 max-w-4xl !text-xl">
            Professional servicing, repairs and maintenance for lawnmowers,
            ride-ons, strimmers, chainsaws and all garden power equipment —
            carried out by experienced engineers in Carlisle.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto">
            <Link to="#" className="w-full sm:w-auto bg-black text-white px-10 py-5 rounded-lg text-xl font-medium hover:bg-black/80 transition-colors shadow-lg">
              Get a Free Quote
            </Link>

            <Link to="#" className="w-full px-10 py-5 rounded-lg text-xl font-medium transition-colors shadow-lg !bg-[rgba(65,158,231,1)] !text-[rgba(255,255,255,1)] sm:w-auto hover:bg-[#71a3c1]/90">View Our Services</Link>
          </div>
        </div>
      </div>
    </section>;
}